export type FilterMeta = Partial<{
  filterProps: unknown;
}>;

export const DEFAULT_CLIENT_FILTERING_DEBOUNCE_WAIT_MILLIS = 250;

export const DEFAULT_SERVER_FILTERING_DEBOUNCE_WAIT_MILLIS = 500;
